var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"skip-nav",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.skipTo.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }